module.exports = __webpack_public_path__ + "static/media/embed-button-fr.9a85f526.jpg";